import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { stats } from '../mock';

const StatsMarquee = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <section ref={ref} className="py-20 bg-slate-950 border-y border-slate-800 overflow-hidden">
      <div className="relative">
        {/* Single slow marquee */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : { opacity: 0 }}
          className="flex"
        >
          <motion.div
            animate={{ x: ["-50%", "0%"] }}
            transition={{
              duration: 40,
              repeat: Infinity,
              ease: "linear",
            }}
            className="flex gap-20 pr-20 whitespace-nowrap"
          >
            {/* Double the stats for seamless loop */}
            {[...stats, ...stats, ...stats].map((stat, index) => (
              <div key={index} className="flex items-center gap-4 px-8">
                <div className="text-center">
                  <div className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent mb-2">
                    {stat.value}
                  </div>
                  <div className="text-slate-400 text-lg font-medium uppercase tracking-wider">
                    {stat.label}
                  </div>
                </div>
                {index < stats.length * 3 - 1 && (
                  <div className="w-px h-20 bg-gradient-to-b from-transparent via-slate-700 to-transparent" />
                )}
              </div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default StatsMarquee;
